import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OCardMiniIcon as OCardMiniIconComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OCardMiniIconConfig = {
  emptyLabel: 'OCardMiniIcon',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-card-mini-icon`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OCardMiniIcon = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-card-mini-icon-comp"
      data-component-name="o-card-mini-icon"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OCardMiniIconConfig} {...props}>
        <OCardMiniIconComp {...props} />
      </EditableComponent>
    </div>
  );
};
